export enum ExecutionTrigger {
    Http = 'http',
    Schedule = 'schedule',
    Event = 'event',
}
